module.exports = __webpack_public_path__ + "static/media/55.b14f961f.jpg";